import React, {
   createContext,
   PropsWithChildren,
   useContext,
   useRef,
   useState
} from 'react'

interface ReportBug {
   customData: Record<string, any>
   addCustomData: (key: string, value: any) => void
}

const ReportBugContext = createContext<ReportBug | null>(null)

interface Props extends PropsWithChildren {
   customData?: Record<string, any>
}

export const ReportBugProvider = (props: Props): React.ReactElement => {
   const [customData, setCustomData] = useState<Record<string, any>>(
      props.customData ?? {}
   )

   const addCustomData = (key: string, value: any): void => {
      const updatedData = { ...customData, [key]: value }
      setCustomData(updatedData)
   }

   return (
      <ReportBugContext.Provider value={{ customData, addCustomData }}>
         {props.children}
      </ReportBugContext.Provider>
   )
}

export const useReportBug = (): ReportBug | null => {
   const reportBug = useContext(ReportBugContext)

   return reportBug
}
